import { NgModule, Injector } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RequiredDocumentsService } from '../../../common/js/services/RequiredDocumentService';

// modules
// ApplicationFormModule must be declared before routes
import { ApplicationFormModule } from '../../../coverpath-common/angular/components/application-form/application-form.module';
import { HomeModule } from './components/home/home.module';
import { AccountCenterModule } from './components/account-center/account-center.module';
import { SharedModule } from './components/shared/shared.module';
import { LoginModule } from './components/login-container/login.module';
import { FaqModule } from './components/faq/faq.module';
import { InsuredAcknowledgementModule } from '../../../coverpath-common/angular/components/acknowledgement/acknowledgement.module';
import { HelpModule } from './components/help/help.module';
import { ModalModule } from '../../../coverpath-common/angular/components/modals/modal.module';
import { BaseFormModule } from '../../../coverpath-common/angular/components/form/base-form.module';
import { AppRoutingModule } from './app.router.module';
import { QuoteModule } from './components/quote/quote.module';
import { AccountSettingsModule } from '../../../coverpath-common/angular/components/account-settings/account-settings.module';
import { UnauthorizedModule } from '../../../coverpath-common/angular/components/unauthorized/unauthorized.module';
import { ConcurrentModificationModule } from './components/concurrentmodification/concurrentmodification.module';
import { ToasterModule } from '../../../coverpath-common/angular/components/overlays/toaster/toaster.module';
import { SignCompleteModule } from './components/sign-complete/sign-complete.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';
import { CpDialogModule } from '../../../coverpath-common/components/dialog/dialog.module';

// components
import { AppComponent } from './components/app.component';
import { PageNotFoundComponent } from './components/shared/page-not-found/page-not-found.component';

// services
import { ApplicationFormGuard } from './services/navguard/application-form.navguard';
import { AuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AuthenticationResolver';
import { AuthGuard } from './services/navguard/auth.navguard';
import { Auth0Guard } from '../../../coverpath-common/angular/navguards/Auth0Guard';
import { ValidAdvisorLinkGuard } from './services/navguard/valid-advisor-link.navguard';
import { ActiveApplicationGuard } from '../../../coverpath-common/js/services/auth-guard/active-application.navguard';
import { ActiveApplicationListGuard } from './services/navguard/active-application-list.navguard';
import { RedirectOnlyGuard } from './services/navguard/redirect-only.navguard';
import { IndividualApplicationAccessGuard } from '../../../coverpath-common/angular/navguards/IndividualApplicationAccessGuard';
import { LogoutModule } from './components/logout/logout.module';
import { AMCAuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AMCAuthenticationResolver';
import { InsuredEsignModule } from './components/esign/insured-esign.module';
import { AdditionalEsignModule } from './components/esign/annuity/additional-esign.module';
import { ViewDocumentsModule } from './components/view-documents/view-documents.module';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    ApplicationFormModule.forRoot(),
    BaseFormModule,
    HomeModule,
    AccountCenterModule,
    AccountSettingsModule,
    SharedModule,
    LoginModule,
    LogoutModule,
    FaqModule,
    InsuredAcknowledgementModule,
    HelpModule,
    ModalModule,
    QuoteModule,
    UnauthorizedModule,
    InsuredEsignModule,
    ViewDocumentsModule,
    AdditionalEsignModule,
    SignCompleteModule,
    ToasterModule,
    ConcurrentModificationModule,
    DesignSystemModule,
    CpDialogModule,
  ],
  providers: [
    ApplicationFormGuard,
    IndividualApplicationAccessGuard,
    AuthenticationResolver,
    AuthGuard,
    ApplicationFormGuard,
    RequiredDocumentsService,
    Auth0Guard,
    ValidAdvisorLinkGuard,
    ActiveApplicationGuard,
    ActiveApplicationListGuard,
    RedirectOnlyGuard,
    AMCAuthenticationResolver,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
